import {memo, useMemo, useState} from "react";
import styles from "./index.module.scss";
import {TypeAsset} from "components/Layout/components/ObjectPanel/TypeAsset";
import {ASSET_TYPE} from "utils";

function FavoritesTab() {
  const [currentType, setCurrentType] = useState(ASSET_TYPE.MODEL);
  const memoizedSetCurrentType = useMemo(() => setCurrentType, []);

  return (
    <div className={styles.container}>
      <TypeAsset currentType={currentType} memoizedSetCurrentType={memoizedSetCurrentType} />
    </div>
  );
}

export default memo(FavoritesTab);
